<template>
  <v-card outlined :loading="loading" :disabled="loading">
    <v-container class="pa-0">
      <v-expansion-panels :value="isOpenByDefault" flat>
        <v-expansion-panel>
          <v-container class="px-6 py-2">
            <v-row class="d-flex align-center">
              <v-col v-if="$slots.default" key="filters" :sm="expansionPanelWidth">
                <v-expansion-panel-header class="px-0">
                  <div class="d-flex align-center">
                    <base-chip class="px-2 mr-2" color="accent" small v-text="queries" />
                    <span>Filters</span>
                  </div>
                </v-expansion-panel-header>
              </v-col>
              <v-spacer v-else />
              <v-col v-if="queryChanged" key="clear" cols="2">
                <v-btn color="error" block small depressed @click="$emit('clear-filters')">
                  Reset Filters
                </v-btn>
              </v-col>
              <v-col v-if="hasSearchBar" key="search" :sm="searchSpan">
                <slot name="search" />
              </v-col>
            </v-row>
          </v-container>
          <v-expansion-panel-content>
            <v-container class="px-0">
              <slot />
            </v-container>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-container>
    <v-divider v-if="hasSearchBar || hasFiltersBar" />
    <slot name="content" />
  </v-card>
</template>

<script>
import BaseChip from '@/components/chips/base-chip'

export default {
  name: 'FilterAccordion',
  components: {
    BaseChip,
  },
  props: {
    defaultOpen: {
      type: Boolean,
      default: false,
    },
    searchSpan: {
      type: [String, Number],
      default: 4,
    },
    queryChanged: {
      type: Boolean,
      default: false,
    },
    queryCount: {
      type: [Number, String, null],
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    expansionPanelWidth() {
      const searchBarSpan = this.hasSearchBar ? Number(this.searchSpan) : 0
      const clearSpan = this.queryChanged ? 2 : 0
      return 12 - clearSpan - searchBarSpan
    },
    queries() {
      return String(this.queryCount || 0)
    },
    hasSearchBar() {
      return this.$slots['search']
    },
    hasFiltersBar() {
      return this.$slots['default']
    },
    isOpenByDefault() {
      return this.defaultOpen ? 0 : undefined
    },
  },
}
</script>
